import { useState } from "react";
import ImageViewer from "../../Components/modern/ImageViewer";
import { Container } from "../../Components/modern/UI";
import { galleryPhotos } from "../../Data/mediaData";

export default function PhotoGallery() {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <>
      <section className="sn-border-b sn-border-line sn-py-12 md:sn-py-16">
        <Container>
          <h1 className="sn-font-display sn-text-4xl sn-leading-tight sn-tracking-[-0.04em] sn-text-forest md:sn-text-5xl">Photo Gallery</h1>
        </Container>
      </section>

      <section aria-label="Photo gallery images" className="sn-pb-12 md:sn-pb-16">
        <Container>
          <div className="sn-grid sn-auto-rows-[220px] sn-gap-5 md:sn-grid-cols-3">
            {galleryPhotos.map((photo, index) => (
              <figure key={photo.id} className={`sn-group sn-relative sn-overflow-hidden sn-rounded-card sn-bg-forest ${photo.span || ""}`}>
                <button type="button" onClick={() => setActiveIndex(index)} className="sn-block sn-h-full sn-w-full sn-text-left" aria-label={`Open ${photo.title}`}>
                  <img src={photo.src} alt={photo.alt} loading={index < 3 ? "eager" : "lazy"} className="sn-h-full sn-w-full sn-object-cover sn-photo sn-transition group-hover:sn-scale-[1.02]" />
                  <span className="sn-absolute sn-inset-x-0 sn-bottom-0 sn-bg-gradient-to-t sn-from-black/70 sn-to-transparent sn-p-5 sn-text-white">
                    <span className="sn-block sn-font-display sn-text-xl">{photo.title}</span>
                  </span>
                </button>
              </figure>
            ))}
          </div>
        </Container>
      </section>

      <ImageViewer items={galleryPhotos} activeIndex={activeIndex} onClose={() => setActiveIndex(null)} onChange={setActiveIndex} title="Photo gallery" />
    </>
  );
}
